<div
  class="maintenance-banner-wrapper"
  role="status"
  aria-live="polite"
>
  <div class="maintenance-banner">
    <div class="maintenance-banner__icon-col">
      <mat-icon aria-hidden="true">warning_amber</mat-icon>
    </div>
    <div class="maintenance-banner__content">
      <p class="maintenance-banner__title">
        <adp-label labelKey="Login_MaintenanceBanner_Title"></adp-label>
      </p>
      <p class="maintenance-banner__description">
        <adp-label labelKey="Login_MaintenanceBanner_Description"></adp-label>
      </p>
    </div>
  </div>
</div>
